import { render, staticRenderFns } from "./AttributesPainter.vue?vue&type=template&id=438a5cda&scoped=true&"
import script from "./AttributesPainter.vue?vue&type=script&lang=js&"
export * from "./AttributesPainter.vue?vue&type=script&lang=js&"
import style0 from "./AttributesPainter.vue?vue&type=style&index=0&id=438a5cda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a5cda",
  null
  
)

export default component.exports